
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href]').forEach(function (link) {
    const href = link.getAttribute('href');


    if (!href) return;


    const isExternal =
      href.startsWith('http') &&
      !href.includes(window.location.hostname);


    if (isExternal) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});

